import { Box, Button, Stack, Typography, styled } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { accountPath } from '@lingoda/router';
import WaveSvg from './assets/wave.svg?component';
import { CharactersBubbles } from './CharactersBubbles';
import { WaveWrapper, Wrapper } from './LayoutWrappers';
import type { ErrorLayoutProps } from './LayoutWrappers';

export const AuthenticatedLayout = ({ errorType, customMessage }: ErrorLayoutProps) => (
    <Wrapper>
        <WaveWrapper top={{ xs: '-60%', md: '-20%' }}>
            <WaveSvg />
        </WaveWrapper>

        {customMessage && (
            <Stack width="100%" py={{ xs: 2, md: 5 }} px={{ xs: 3, md: 6 }} zIndex={2}>
                <Typography variant="h2">{customMessage}</Typography>
            </Stack>
        )}

        <CharactersContainer>
            <CharactersBubbles errorType={errorType} />
        </CharactersContainer>

        <Stack alignItems="center" py={4}>
            <Button color="primary" variant="contained" href={accountPath()}>
                {trans('back-to-homepage', {}, 'public-common')}
            </Button>
        </Stack>
    </Wrapper>
);

const CharactersContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 420,

    [theme.breakpoints.up('md')]: {
        height: 720,
    },

    [theme.breakpoints.up('lg')]: {
        height: 600,
    },
}));
